module.exports = __webpack_public_path__ + "media/images/icon_search_skill-3e31b51775503aa69a0ace8a4efd2daa.png";